import { OsTypeEnum } from "@/model/data/enums/OsTypeEnum";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { Installation } from "../Installation";
import { Organization } from "../organizations/Organization";
import { UpdatePackageAdditionalRequirement } from "./UpdatePackageAdditionalRequirement";

export class UpdatePackage {
    public id: number;

    /**Nome del file del pacchetto di aggiornamento, deve essere univoco */
    public fileName: string;

    public softwareName: string;

    /**Tipo di aggiornamento */
    public updateType: UpdateTypeEnum;

    /**Versione del pacchetto di aggiornamento */
    public version: string;

    /**Sistema operativo su cui installare (per ora serve solo a CAOS) */
    public osType: OsTypeEnum;

    /**Versione minima installata a cui poter applicare il pacchetto, se null non c'è nessun vincolo */
    public targetMinVersion: string;

    /**Sistema operativo  minimo installato a cui poter applicare il pacchetto, se null non c'è nessun vincolo */
    public osMinVersion: string;

    /**Modelli di dispositivo target */
    public targetModels: string[] = [];

    /**Stringa dei modelli di dispositivo target separati da virgola */
    public targetDeviceModelsCsv: string;

    /**Modello di sensore di riconoscimento target */
    public targetRecognitionSensorModel: string;

    /**Lista dispositivi a cui può essere fornito il pacchetto di aggiornamento */
    public targetInstallations: Installation[] = [];

    /**Lista di requisiti necessari per applicare il pacchetto di aggiornamento*/
    public additionalRequirements: UpdatePackageAdditionalRequirement[] = [];

    /**Versione minima dell'agente per poter applicare questo pacchetto */
    public agentMinVersion: string;

    /**Descrizione del pacchetto, usata solo per le custom actions */
    public description: string;

    public uploadTimestamp: Date;

    public targetOrganizations: Organization[] = [];

    public parse(obj: any) {
        if (obj.Id) this.id = obj.Id;
        if (obj.FileName) this.fileName = obj.FileName;
        if (obj.SoftwareName) this.softwareName = obj.SoftwareName;

        if (obj.UpdateType != null && Object.values(UpdateTypeEnum).includes(obj.UpdateType)) this.updateType = obj.UpdateType;

        if (obj.Version) this.version = obj.Version;

        if (obj.OsType != null && Object.values(OsTypeEnum).includes(obj.OsType)) this.osType = obj.OsType;

        if (obj.TargetMinVersion) this.targetMinVersion = obj.TargetMinVersion;
        if (obj.OsMinVersion) this.osMinVersion = obj.OsMinVersion;

        if (obj.TargetModels && obj.TargetModels.length > 0) {
            obj.TargetModels.forEach((e) => {
                this.targetModels.push(e);
            });
        }

        if (obj.TargetDeviceModelsCsv) this.targetDeviceModelsCsv = obj.TargetDeviceModelsCsv;
        if (obj.TargetRecognitionSensorModel) this.targetRecognitionSensorModel = obj.TargetRecognitionSensorModel;

        if (obj.AdditionalRequirements && obj.AdditionalRequirements.length > 0) {
            obj.AdditionalRequirements.forEach((e) => {
                let m = new UpdatePackageAdditionalRequirement();
                m.fillFromJson(e);
                this.additionalRequirements.push(m);
            });
        }

        if (obj.TargetInstallations && obj.TargetInstallations.length > 0) {
            obj.TargetInstallations.forEach((e) => {
                let m: Installation = new Installation();
                m.parse(e);
                this.targetInstallations.push(m);
            });
        }

        if (obj.AgentMinVersion) this.agentMinVersion = obj.AgentMinVersion;
        if (obj.Description) this.description = obj.Description;
        if (obj.UploadTimestamp) this.uploadTimestamp = obj.UploadTimestamp;

        if (obj.TargetOrganizations && obj.TargetOrganizations.length > 0) {
            obj.TargetOrganizations.forEach((e) => {
                let o: Organization = new Organization();
                o.parse(e);
                this.targetOrganizations.push(o);
            });
        }
    }
}
